export function errorParser(error: string) {
  if (!error) {
    return 'error_title';
  }
  if (error.includes('USER_RESTRICTIONS_EXCEEDED_MAXIMUM_ALLOWED_VALUE')) {
    return 'user_restrictions_exceeded_maximum_allowed_value';
  }

  if (error.includes('INSUFFICIENT_BET_BALANCE')) {
    return 'insufficient_bet_balance';
  }

  return error;
}
